import { UploadFileStatuses } from "../../../../Engine/Core/ModalManager/Modals/Utils/Types";

import { UnitItem } from "./FufAndAttachmentsUploadModalTypes";

export type Action =
    | ReturnType<typeof addItems>
    | ReturnType<typeof removeItem>
    | ReturnType<typeof setStatus>
    | ReturnType<typeof setProgress>
    | ReturnType<typeof updateItem>
    | ReturnType<typeof setFileUri>
    | ReturnType<typeof setNdsTotalSum>
    | ReturnType<typeof setGfv>
    | ReturnType<typeof removeByGfv>
    | ReturnType<typeof checkUniqueGfv>;

export const setStatus = (payload: { id: string; status: UploadFileStatuses; errorMessage?: string }) =>
    ({ type: "setStatus", payload: payload }) as const;
export const addItems = (payload: UnitItem[]) => ({ type: "addItems", payload: payload }) as const;
export const removeItem = (payload: { id: string }) => ({ type: "removeItem", payload: payload }) as const;
export const setProgress = (payload: { id: string; progressText: string }) =>
    ({ type: "setProgress", payload: payload }) as const;
export const updateItem = (payload: { id: string; unitItem: UnitItem }) =>
    ({ type: "updateItem", payload: payload }) as const;
export const setFileUri = (payload: { id: string; fileUri?: string }) =>
    ({ type: "setFileUri", payload: payload }) as const;
export const setNdsTotalSum = (payload: { id: string; ndsTotalSum?: string }) =>
    ({ type: "setNdsTotalSum", payload: payload }) as const;
export const setGfv = (payload: { id: string; gfv?: string }) => ({ type: "setGfv", payload: payload }) as const;
export const removeByGfv = (payload: { gfv: string }) => ({ type: "removeByGfv", payload: payload }) as const;
export const checkUniqueGfv = (payload: { gfv: string }) => ({ type: "checkUniqueGfv", payload: payload }) as const;

const updateById = (state: UnitItem[], id: string, update: (unitItem: UnitItem) => UnitItem) =>
    state.map(unitItem => {
        if (unitItem.id === id) {
            return update(unitItem);
        }

        return unitItem;
    });

export const fufAndAttachmentsReducer = (state: UnitItem[], action: Action) => {
    switch (action.type) {
        case "setStatus":
            return updateById(state, action.payload.id, unitItem => ({
                ...unitItem,
                status: action.payload.status,
                errorMessage: action.payload.errorMessage,
            }));

        case "addItems":
            return [...state, ...action.payload];

        case "removeItem":
            return state.filter(item => item.id !== action.payload.id);

        case "setProgress":
            return updateById(state, action.payload.id, unitItem => ({
                ...unitItem,
                progressText: action.payload.progressText,
            }));

        case "updateItem":
            return updateById(state, action.payload.unitItem.id, unitItem => unitItem);

        case "setFileUri":
            return updateById(state, action.payload.id, unitItem => ({
                ...unitItem,
                file: {
                    ...unitItem.file,
                    contentUri: action.payload.fileUri,
                },
            }));

        case "setNdsTotalSum":
            return updateById(state, action.payload.id, unitItem => ({
                ...unitItem,
                file: {
                    ...unitItem.file,
                    ndsTotalSum: action.payload.ndsTotalSum,
                },
            }));

        case "setGfv":
            return updateById(state, action.payload.id, unitItem => ({
                ...unitItem,
                gfv: action.payload.gfv ?? "none",
            }));

        case "removeByGfv":
            return state.filter(unitItem => unitItem.gfv !== action.payload.gfv);

        case "checkUniqueGfv": {
            const errorMessage = "Можно загрузить только один файл декларации";

            if (state.filter(item => item.gfv === action.payload.gfv).length <= 1) {
                return state.map(unitItem =>
                    unitItem.errorMessage === errorMessage
                        ? {
                              ...unitItem,
                              status: UploadFileStatuses.success,
                              errorMessage: undefined,
                          }
                        : unitItem
                );
            }

            return state.map(unitItem => {
                if (unitItem.gfv === action.payload.gfv && unitItem.status === UploadFileStatuses.success) {
                    return {
                        ...unitItem,
                        status: UploadFileStatuses.error,
                        errorMessage: errorMessage,
                    };
                }

                return unitItem;
            });
        }

        default:
            return state;
    }
};
